module.exports = __webpack_public_path__ + "static/img/weather39.7ab74763.png";